import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

const sanitizeForPDF = (val) => String(val == null ? '' : val).replace(/₹/g, 'Rs.');

export const getExportValue = (row, col) => {
  if (col.accessor) return col.accessor(row);
  if (col.key) return row[col.key];
  return row;
};

export const exportCSV = (data, filename, columns) => {
  const escape = (str) => `"${String(str == null ? '' : str).replace(/"/g, '""')}"`;
  const headers = columns.map((c) => c.header).join(',');
  const rows = data
    .map((row) => columns.map((c) => escape(getExportValue(row, c))).join(','))
    .join('\n');
  const csv = `${headers}\n${rows}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const exportXLSX = (data, filename, columns) => {
  const rows = data.map((row) => {
    const obj = {};
    columns.forEach((c) => {
      obj[c.header] = getExportValue(row, c);
    });
    return obj;
  });
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Data');
  XLSX.writeFile(wb, `${filename}.xlsx`);
};

export const exportPDF = (data, filename, columns, title = '', subtitle = '') => {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm' });
  let startY = 10;
  if (title) {
    doc.setFontSize(14);
    doc.text(sanitizeForPDF(title), 14, 15);
    startY = 22;
  }
  if (subtitle) {
    doc.setFontSize(10);
    const lines = subtitle.split('\n').map(sanitizeForPDF);
    let y = startY;
    lines.forEach((line) => {
      doc.text(line, 14, y);
      y += 6;
    });
    startY = y + 2;
  }
  const head = [columns.map((c) => sanitizeForPDF(c.header))];
  const body = data.map((row) =>
    columns.map((c) => sanitizeForPDF(getExportValue(row, c)))
  );
  doc.autoTable({
    head,
    body,
    startY,
    styles: { fontSize: 8, overflow: 'linebreak' },
    headStyles: { fillColor: [37, 99, 235], textColor: 255 },
    theme: 'striped',
    margin: { top: 10, right: 10, bottom: 10, left: 10 }
  });
  doc.save(`${filename}.pdf`);
};

export const printData = (data, columns, title = '', subtitle = '') => {
  const subtitleHtml = subtitle ? `<p class="subtitle">${subtitle.replace(/\n/g, '<br>')}</p>` : '';
  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>${title}</title>
      <style>
        body { font-family: Arial, sans-serif; margin: 20px; color: #000; }
        h2 { margin-bottom: 4px; }
        .subtitle { font-size: 12px; margin: 0 0 12px 0; color: #333; }
        table { width: 100%; border-collapse: collapse; font-size: 12px; }
        th, td { border: 1px solid #333; padding: 6px; text-align: left; }
        th { background: #2563eb; color: #fff; }
        tr:nth-child(even) { background: #f3f4f6; }
        .text-right { text-align: right; }
      </style>
    </head>
    <body>
      <h2>${title}</h2>
      ${subtitleHtml}
      <table>
        <thead>
          <tr>${columns.map((c) => `<th>${c.header}</th>`).join('')}</tr>
        </thead>
        <tbody>
          ${data
            .map(
              (row) =>
                `<tr>${columns
                  .map((c) => {
                    const val = getExportValue(row, c);
                    const align = c.align === 'right' ? 'class="text-right"' : '';
                    return `<td ${align}>${val == null ? '' : val}</td>`;
                  })
                  .join('')}</tr>`
            )
            .join('')}
        </tbody>
      </table>
    </body>
    </html>
  `;
  const printWindow = window.open('', '_blank');
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
};
